import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { FixedAsset, FixedAssetDetail } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type FixedAssetContextType = {
  fixedAsset?: FixedAsset;
  setFixedAsset: Dispatch<SetStateAction<FixedAsset | undefined>>;
  fixedAssetDetails?: FixedAssetDetail[];
  setFixedAssetDetails: Dispatch<SetStateAction<FixedAssetDetail[] | undefined>>;
};

export const FixedAssetContext = createContext<FixedAssetContextType>({
  fixedAsset: undefined,
  setFixedAsset: () => {},
  fixedAssetDetails: undefined,
  setFixedAssetDetails: () => {},
});

export const FixedAssetProvider = ({ children }: Props) => {
  const [fixedAsset, setFixedAsset] = useState<FixedAsset>();
  const [fixedAssetDetails, setFixedAssetDetails] = useState<FixedAssetDetail[]>();

  return <FixedAssetContext.Provider value={{ fixedAsset, setFixedAsset, fixedAssetDetails, setFixedAssetDetails }}>{children}</FixedAssetContext.Provider>;
};

export const useCurrentFixedAsset = () => {
  return useContext(FixedAssetContext);
};
